import React, { useEffect } from "react";
import { useMount, useSetState } from "ahooks";
import TopFilterBase from "../../../../commonComponents/listBase/TopFilterBase";
import InputLabel from "../../../../../base/basicComponents/inputLabel";
import NormalSelect from "../../../../../base/basicComponents/select";
import Buttons from "../../../../../base/basicComponents/button";
import changeHistoryService from "../../../../../service/changeHistory";
import styles from "../../../toDoList/toDoListSections/topFilter/index.module.scss";
import "../../../../../assets/css/style.css";

export default function TopFilter(props: any) {
  const { tab } = props;
  const { sortList, handleChange, handleDeSelect, handleFilterOption } = TopFilterBase();

  /* state about selects' data */
  const [filterOptionList, setFilterOptionList] = useSetState({
    processCategory: [],
    processStatus: [],
  });

  /* state about select's selected data */
  const [selectOptions, setSelectOptions] = useSetState({
    processCategory: [],
    processStatus: [],
  });

  const handleOptionList = (list: any, isSort: any) => {
    let tempOptionList: any[] = [];
    list.map((item: any, index: any) => {
      let optionItem = { name: item.value, value: item.key, index: index };
      tempOptionList.push(optionItem);
    });

    return tempOptionList;
  };

  const onSuccess = (response: any, type: any) => {
    let option;
    switch (type) {
      case "processCategory":
        // @ts-ignore
        option = handleOptionList(response.data);
        // @ts-ignore
        setFilterOptionList({ processCategory: option });
        break;
      case "processStatus":
        // @ts-ignore
        option = handleOptionList(response.data);
        setFilterOptionList({
          // @ts-ignore
          processStatus: option,
        });
        break;
      default:
        break;
    }
  };

  /* callback about when call api error */
  const onError = (error: any) => {
    console.log(error);
  };

  const handleFilterClick = () => {
    props.handleFilterClick(filterOptionList, selectOptions);
  };

  const handleClearClick = () => {
    const defaultOption = {
      processStatus: [],
      processCategory: [],
    };
    setSelectOptions(defaultOption);
    filterOptionList.processCategory.sort((s, t) => sortList(s, t));
    filterOptionList.processStatus.sort((s, t) => sortListByIndex(s, t));
    props.handleFilterClick(filterOptionList, defaultOption);
  };

  const handleSelectAll = (filterName: any) => {
    // @ts-ignore
    const optionList = filterOptionList[filterName];
    const allOptionsValue = optionList.map((item: any) => item.value);
    const isProcessStatus = filterName === "processStatus";

    // @ts-ignore
    setSelectOptions({
      [filterName]: allOptionsValue,
    });
    // @ts-ignore
    setFilterOptionList({
      [filterName]: [...handleChange(optionList, allOptionsValue, isProcessStatus)],
    });
  };

  const handleDeselectAll = (filterName: any) => {
    // @ts-ignore
    const optionList = filterOptionList[filterName];
    const isProcessStatus = filterName === "processStatus";

    // @ts-ignore
    setSelectOptions({
      [filterName]: [],
    });
    // @ts-ignore
    setFilterOptionList({
      [filterName]: isProcessStatus
        ? [...optionList.sort((s: any, t: any) => sortListByIndex(s, t))]
        : [...optionList.sort((s: any, t: any) => sortList(s, t))],
    });
  };

  const getProcessStatus = () => {
    changeHistoryService.getProcessStatusList(onSuccess, onError, "processStatus");
  };

  const getProcessCategory = () => {
    const para = {
      ProcedureTaskId: props.procedureTaskId,
      HistoryType: props.tab,
    };
    changeHistoryService.getCategoryList(para, onSuccess, onError, "processCategory");
  };

  /* function about sort filter list by alphabetical order */
  const sortListByIndex = (s: any, t: any) => {
    const a = s.index;
    const b = t.index;
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  };

  useEffect(() => {
    getProcessCategory();
    getProcessStatus();
    setSelectOptions({
      processStatus: [],
      processCategory: [],
    });

    const filterOptionPara = {
      processStatus: [],
      processCategory: [],
    };
    const selectOptionsPara = {
      processStatus: [],
      processCategory: [],
    };

    props.handleFilterClick(filterOptionPara, selectOptionsPara);
  }, [tab]);

  return (
    <div className={styles.topFilterContainer}>
      <div className={styles.topFilterSelects}>
        <div className={styles.topFilterSelectItem}>
          <InputLabel text="Process Category" className={`${styles.topFilterSelectLabel} fs-14`} />
          <NormalSelect
            value={selectOptions.processCategory}
            optionList={filterOptionList.processCategory}
            className="topFilterSelectInput"
            mode="multiple"
            showArrow={true}
            maxTagCount="responsive"
            testid="change-history-category-select"
            handleChange={(e: any) => {
              const optionList = filterOptionList.processCategory;
              setSelectOptions({
                processCategory: e,
              });
              setFilterOptionList({
                // @ts-ignore
                processCategory: [
                  ...handleChange(optionList, e),
                  ...optionList.sort((s, t) => sortList(s, t)),
                ],
              });
            }}
            handleDeSelect={(e: any) => {
              const selectList = [...selectOptions.processCategory];
              setSelectOptions({
                processCategory: handleDeSelect(e, selectList),
              });
            }}
            handleFilterOption={(input: any, option: any) => handleFilterOption(input, option)}
            isNeedSelectAll={filterOptionList.processCategory.length > 0}
            handleSelectAll={() => handleSelectAll("processCategory")}
            handleDeselectAll={() => handleDeselectAll("processCategory")}
          />
        </div>
        {
          <div className={styles.topFilterSelectItem}>
            <InputLabel text="Process Status" className={`${styles.topFilterSelectLabel} fs-14`} />
            <NormalSelect
              value={selectOptions.processStatus}
              optionList={filterOptionList.processStatus}
              className="topFilterSelectInput"
              mode="multiple"
              showArrow={true}
              maxTagCount="responsive"
              testid="change-history-status-select"
              handleChange={(e: any) => {
                const optionList = filterOptionList.processStatus;
                setSelectOptions({
                  processStatus: e,
                });
                setFilterOptionList({
                  // @ts-ignore
                  processStatus: [
                    ...handleChange(optionList, e, true),
                    ...optionList.sort((s, t) => sortListByIndex(s, t)),
                  ],
                });
              }}
              handleDeSelect={(e: any) => {
                const selectList = [...selectOptions.processStatus];
                setSelectOptions({
                  processStatus: handleDeSelect(e, selectList),
                });
              }}
              handleFilterOption={(input: any, option: any) => handleFilterOption(input, option)}
              isNeedSelectAll={filterOptionList.processStatus.length > 0}
              handleSelectAll={() => handleSelectAll("processStatus")}
              handleDeselectAll={() => handleDeselectAll("processStatus")}
            />
          </div>
        }
      </div>
      <div className={styles.topFilterBtns}>
        <Buttons
          color="blue"
          size="middle"
          onClick={handleFilterClick}
          testid="change-history-filter-btn"
        >
          Filter
        </Buttons>
        <Buttons
          color="grey"
          size="middle"
          onClick={handleClearClick}
          testid="change-history-clear-btn"
        >
          Clear
        </Buttons>
      </div>
    </div>
  );
}
